var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AccordionCard',{staticClass:"fill-height",attrs:{"title":"Finished Jobs"}},[_c('SimpleList',{ref:"list",attrs:{"favourites-key":"agency-completed-jobs","headers":_vm.headers,"columns":_vm.columns,"filters":_vm.filters,"actions":_vm.actions,"route":"/jobs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }